import { DatePicker, Panel, PanelType } from "@fluentui/react";
import { useCallback, useEffect, useState } from "react";
import { PanelHeader } from "../../../components/Panel/PanelHeader";
import { PanelFooter } from "../../../components/Panel/PanelFooter";
import { _formatDate, onFormatDate } from "../../../utils/helpers/dateHelpers";
import { ComboBoxIDS } from "../../../components/generic/ComboBoxIDS";
import { useComboSupervisores } from "../../../hooks/combosHooks/useComboSupervisores";
import {
  IDataSupersivor,
  IModelRegistrarSuplente,
} from "../../../Interfaces/IPersona";
import { useRegistrarSupervisorSuplente } from "../../../hooks/Personas/useRegistrarSupervisorSuplente";
import { MensajeBar } from "../../../components/generic/ManejoResponseMessage/MessageBar";
import IdicadorProgress from "../../../components/generic/IndicadorProgress";

interface IPanelRegistrarSuplente {
  isOpen: boolean;
  onDismiss: () => void;
  supervisor: IDataSupersivor;
}
export const PanelRegistrarSuplente = (props: IPanelRegistrarSuplente) => {
  const {
    SupervisoresCombo,
    _onkeyUpSearchSupervisores,
    comboBoxRefSupervisores,
    obtenerPuesto,
    onClickComboSupevisores,
    search,
  } = useComboSupervisores();

  const [fechas, setFechas] = useState({
    fechaInicio: new Date(),
    fechaFin: new Date(),
  });
  const [modelRequest, setModelRequest] = useState<IModelRegistrarSuplente>({
    supervisorId: null,
    suplenteId: null,
    fechaInicio: _formatDate(new Date(), ","),
    fechaFin: _formatDate(new Date(), ","),
  });
  const { isSend, ocultarMensaje, postRegistrarSuplente, response } =
    useRegistrarSupervisorSuplente(props.onDismiss);

  const onRenderFooterPanel = useCallback(
    () => (
      <>
        <PanelFooter
          onClick={() => {
            postRegistrarSuplente(modelRequest);
          }}
          onDismiss={props.onDismiss}
          texto="Registrar"
        />
      </>
    ),
    [props.onDismiss, modelRequest, postRegistrarSuplente]
  );
  const onRenderHeaderPanel = useCallback(
    () => (
      <>
        <PanelHeader
          key={"agregar"}
          nameIconHeader="Transition"
          subTextHeader={`Registrar Suplente del Supervisor ${props.supervisor?.nombreSupervisor}`}
          textHeader="Registrar Suplente"
        />
      </>
    ),
    [props.supervisor]
  );
  const _onSelectDate = (date, text) => {
    switch (text) {
      case "inicio":
        setModelRequest({
          ...modelRequest,
          fechaInicio: _formatDate(date, ","),
          supervisorId: props.supervisor.supervisorId,
        });
        setFechas({ ...fechas, fechaInicio: date });
        break;
      case "fin":
        setModelRequest({
          ...modelRequest,
          fechaFin: _formatDate(date, ","),
          supervisorId: props.supervisor.supervisorId,
        });
        setFechas({ ...fechas, fechaFin: date });

        break;
      default:
        break;
    }
  };
  const _onChangeCombo = (e, o) => {
    if (e !== undefined) {
      if (o?.key) {
        setModelRequest({
          ...modelRequest,
          suplenteId: o.key,
          supervisorId: props.supervisor.supervisorId,
        });
      }
    }
  };

  useEffect(() => {
    if (!props.isOpen) {
      setFechas({
        fechaInicio: new Date(),
        fechaFin: new Date(),
      });
      setModelRequest({
        supervisorId: null,
        suplenteId: null,
        fechaInicio: _formatDate(new Date(), ","),
        fechaFin: _formatDate(new Date(), ","),
      });
    }
  }, [props.isOpen]);
  return (
    <>
      <Panel
        isOpen={props.isOpen}
        onDismiss={props.onDismiss}
        onRenderHeader={onRenderHeaderPanel}
        onRenderFooter={onRenderFooterPanel}
        isFooterAtBottom={true}
        closeButtonAriaLabel="Close"
        customWidth={"500px"}
        type={PanelType.custom}
        isLightDismiss
      >
        <>
          <MensajeBar
            response={response}
            ocultar={() => {
              ocultarMensaje();
            }}
          />
          {isSend == true ? (
            <IdicadorProgress isSend={isSend} subText="Espere un momento..." />
          ) : (
            <>
              <br />
              <div className="ms-Grid" dir="ltr">
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
                    <DatePicker
                      label="Fecha de:"
                      placeholder="dd/mm/yyyy"
                      ariaLabel="Seleccione una fecha"
                      value={fechas.fechaInicio}
                      onSelectDate={(date?: any) => {
                        _onSelectDate(date, "inicio");
                      }}
                      formatDate={onFormatDate}
                      underlined
                    />
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg6">
                    <DatePicker
                      label="a:"
                      placeholder="dd/mm/yyyy"
                      ariaLabel="Seleccione una fecha"
                      value={fechas.fechaFin}
                      onSelectDate={(date?: any) => {
                        _onSelectDate(date, "fin");
                      }}
                      formatDate={onFormatDate}
                      minDate={fechas.fechaInicio}
                      underlined
                    />
                  </div>
                </div>
                <br />
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                    <ComboBoxIDS
                      title="Supervisor Suplente:"
                      componentRef={comboBoxRefSupervisores}
                      selectedKey={modelRequest?.suplenteId}
                      KeyUp={_onkeyUpSearchSupervisores}
                      onChange={(e, o) => {
                        _onChangeCombo(e, o);
                      }}
                      onClick={onClickComboSupevisores}
                      options={SupervisoresCombo}
                      onRenderOption={(option) => (
                        <>
                          {option && (
                            <div>
                              <span>{option?.text}</span>
                              <br />
                              <span
                                style={{
                                  paddingBottom: "0.9px",
                                  color: "#777",
                                  fontSize: "0.7rem",
                                }}
                              >
                                {obtenerPuesto(option?.key)}
                              </span>
                            </div>
                          )}
                        </>
                      )}
                    />
                  </div>
                </div>
                {/*<pre>{JSON.stringify(modelRequest, null, 2)}</pre> */}
              </div>
            </>
          )}
        </>
      </Panel>
    </>
  );
};
